import Create from './create/CreateChannelDistributionSectionTemplate';
import Edit from './edit/EditChannelDistributionSectionTemplate';
import Individual from './individual/ChannelDistributionTemplateSection';

export default { Create, Individual, Edit };
